module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/adb3d064c06ba450a7c6da5ca21c7527.png";